module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    attrs: {
      "rules": _vm.rules,
      "labelWidth": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "javaXms"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.option.javaXms),
      callback: function($$v) {
        _vm.option.javaXms = $$v
      },
      expression: "option.javaXms"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "javaXmx"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.option.javaXmx),
      callback: function($$v) {
        _vm.option.javaXmx = $$v
      },
      expression: "option.javaXmx"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Gamemode"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.option.properties.gamemode),
      callback: function($$v) {
        _vm.option.properties.gamemode = $$v
      },
      expression: "option.properties.gamemode"
    }
  }, _vm._l((_vm.present.gamemode), function(item, index) {
    return _c('el-radio-button', {
      key: "gamemode",
      attrs: {
        "label": index
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Difficulty"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.option.properties.difficulty),
      callback: function($$v) {
        _vm.option.properties.difficulty = $$v
      },
      expression: "option.properties.difficulty"
    }
  }, _vm._l((_vm.present.difficulty), function(item, index) {
    return _c('el-radio-button', {
      key: "gamemode",
      attrs: {
        "label": index
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "PVP"
    }
  }, [_c('el-switch', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.option.properties.pvp),
      callback: function($$v) {
        _vm.option.properties.pvp = $$v
      },
      expression: "option.properties.pvp"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Max Players"
    }
  }, [_c('el-slider', {
    attrs: {
      "min": 1,
      "max": 20,
      "showInput": ""
    },
    model: {
      value: (_vm.option.properties['max-players']),
      callback: function($$v) {
        var $$exp = _vm.option.properties,
          $$idx = 'max-players';
        if (!Array.isArray($$exp)) {
          _vm.option.properties['max-players'] = $$v
        } else {
          $$exp.splice($$idx, 1, $$v)
        }
      },
      expression: "option.properties['max-players']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Seed"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "size": "small"
    },
    model: {
      value: (_vm.option.properties['level-seed']),
      callback: function($$v) {
        var $$exp = _vm.option.properties,
          $$idx = 'level-seed';
        if (!Array.isArray($$exp)) {
          _vm.option.properties['level-seed'] = $$v
        } else {
          $$exp.splice($$idx, 1, $$v)
        }
      },
      expression: "option.properties['level-seed']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Server Port"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "size": "small"
    },
    model: {
      value: (_vm.option.properties['server-port']),
      callback: function($$v) {
        var $$exp = _vm.option.properties,
          $$idx = 'server-port';
        if (!Array.isArray($$exp)) {
          _vm.option.properties['server-port'] = $$v
        } else {
          $$exp.splice($$idx, 1, $$v)
        }
      },
      expression: "option.properties['server-port']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Enable Command Block"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.option.properties['enable-command-block']),
      callback: function($$v) {
        var $$exp = _vm.option.properties,
          $$idx = 'enable-command-block';
        if (!Array.isArray($$exp)) {
          _vm.option.properties['enable-command-block'] = $$v
        } else {
          $$exp.splice($$idx, 1, $$v)
        }
      },
      expression: "option.properties['enable-command-block']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "View Distance"
    }
  }, [_c('el-slider', {
    attrs: {
      "min": 3,
      "max": 16,
      "showInput": ""
    },
    model: {
      value: (_vm.option.properties['view-distance']),
      callback: function($$v) {
        var $$exp = _vm.option.properties,
          $$idx = 'view-distance';
        if (!Array.isArray($$exp)) {
          _vm.option.properties['view-distance'] = $$v
        } else {
          $$exp.splice($$idx, 1, $$v)
        }
      },
      expression: "option.properties['view-distance']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Online Mode"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.option.properties['online-mode']),
      callback: function($$v) {
        var $$exp = _vm.option.properties,
          $$idx = 'online-mode';
        if (!Array.isArray($$exp)) {
          _vm.option.properties['online-mode'] = $$v
        } else {
          $$exp.splice($$idx, 1, $$v)
        }
      },
      expression: "option.properties['online-mode']"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-58c7f144"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/form/ServerOption.vue
// module id = 168
// module chunks = 1